module.exports = __webpack_public_path__ + "img/40_38_030_950.bca12366.jpg";